import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useDeleteTeam({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({ teamId, password }: { teamId: number | string; password: string }) => {
    const response = await httpClient.delete(`team/team`, {
      headers: {
        'X-Team': teamId,
      },
      data: {
        password: password,
      },
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Space deleted successfully')
      queryClient.invalidateQueries({ queryKey: ['teams'] })
      queryClient.invalidateQueries({ queryKey: ['team-details'] })
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}